import { serviceURL } from "../../../../utils/service-url";
import { ImageNode } from "../nodes/image-node";
import { VideoNode } from "../nodes/video-node";

import type { DesignHuddleNode } from "../nodes/design-huddle-node";

// Scaling is just a URL: nothing is drawn or uploaded. Only the image service resizes from the
// query string, so anything else is left at its natural size.
export function getNewImageUrl(
  node: ImageNode | DesignHuddleNode | VideoNode,
  imageResize: { maxWidth: number },
): { node: ImageNode | DesignHuddleNode | VideoNode; url: string } {
  const url =
    node instanceof ImageNode
      ? node.__url
      : node instanceof VideoNode
        ? node.__thumbnailUrl
        : node.getImageUrl();
  if (node.__proportionOfMaxWidth === 1 || url.endsWith(".gif")) return { node, url };
  if (!url.startsWith(serviceURL("images"))) return { node, url };

  const resized = new URL(url);
  const width = Math.floor((node.__proportionOfMaxWidth ?? 1) * imageResize.maxWidth);
  resized.searchParams.set("width", `${width}`);
  resized.searchParams.set("height", `${Math.floor(width / (node.__aspect ?? 1))}`);

  return { node, url: resized.toString() };
}
